import { RouteObject } from 'react-router-dom'

// Import all Report step components
import {
  Step1,
  Step2,
  Step3,
  Step4,
  Step5,
  Step6,
  Step7,
  Step8,
  Step9,
  Step10,
  Step11,
  Step12,
  Step13,
  Step14,
} from '../pages/Report'

// Import other user pages
import ShowLabs from '../pages/Labs/ShowLabs'
import AddLab from '../pages/Labs/AddLab'
import EditLab from '../pages/Labs/EditLab'
import ArchivedLabs from '../pages/Labs/ArchivedLabs'
import Profile from '../pages/Profile'
import Help from '../pages/Help'
import Print from '../pages/Print'
import ResearchPage from '../pages/Research/ShowResearch'
import ResearchDetailsPage from '../pages/Research/ResearchDetails'
import AddResearchPage from '../pages/Research/AddResearch'
import EditResearchPage from '../pages/Research/EditResearch'

const userRoutes: RouteObject[] = [
  // ============================================================================
  // Profile & Help
  // ============================================================================
  { path: '/profile', element: <Profile /> },
  { path: '/help', element: <Help /> },

  // ============================================================================
  // Monthly Report Steps (1-14)
  // ============================================================================
  { path: '/report/:month/1', element: <Step1 /> },
  { path: '/report/:month/2', element: <Step2 /> },
  { path: '/report/:month/3', element: <Step3 /> },
  { path: '/report/:month/4', element: <Step4 /> },
  { path: '/report/:month/5', element: <Step5 /> },
  { path: '/report/:month/6', element: <Step6 /> },
  { path: '/report/:month/7', element: <Step7 /> },
  { path: '/report/:month/8', element: <Step8 /> },
  { path: '/report/:month/9', element: <Step9 /> },
  { path: '/report/:month/10', element: <Step10 /> },
  { path: '/report/:month/11', element: <Step11 /> },
  { path: '/report/:month/12', element: <Step12 /> },
  { path: '/report/:month/13', element: <Step13 /> },
  { path: '/report/:month/14', element: <Step14 /> },
  { path: '/report/:month/100', element: <Step14 /> },

  // ============================================================================
  // Labs
  // ============================================================================
  { path: '/labs', element: <ShowLabs /> },
  { path: '/labs/add/:labTitle', element: <AddLab /> },
  { path: '/labs/edit/:userLabId', element: <EditLab /> },
  { path: '/labs/archived', element: <ArchivedLabs /> },

  // ============================================================================
  // Research Directory
  // ============================================================================
  { path: '/research', element: <ResearchPage /> },
  { path: '/research/add', element: <AddResearchPage /> },
  { path: '/research/:id', element: <ResearchDetailsPage /> },
  { path: '/research/edit/:id', element: <EditResearchPage /> },

  // ============================================================================
  // Print
  // ============================================================================
  { path: '/print', element: <Print /> },
]

export default userRoutes
